export const DashboardNavLink = 'dashboard';
